module.exports = __webpack_public_path__ + "static/Orkney-Light-37f7fd0bc10aa8ca0a072daaa4ae7631.woff2";